import React from 'react'

export function getLazyComponent(
  factory: () => Promise<Record<string, unknown>>,
) {
  return React.lazy(async () => {
    const modules = await factory()

    for (const module in modules) {
      const reactComponent = modules[module]

      // To check if the module is a valid React component the function check is enough
      // But in case of building memoed or forwardRef components (HoC), we need to check for the $$typeof property
      if (
        reactComponent &&
        (typeof reactComponent === 'function' ||
          (typeof reactComponent === 'object' && '$$typeof' in reactComponent))
      )
        return {
          default: reactComponent as React.ComponentType,
        }
    }

    throw new Error('No valid React component found in the modules')
  })
}
